/*=============================================== Fallback ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { stringifyPx } from "js-utils-julseb";
import Variables from "./Variables";
/*==================== Component ====================*/
var Fallback = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n"], ["\n    position: relative;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n"])), function (_a) {
    var $width = _a.$width;
    return ($width ? stringifyPx($width) : "100%");
}, function (_a) {
    var $height = _a.$height;
    return ($height ? stringifyPx($height) : "auto");
}, Variables.Colors.Gray500);
export default Fallback;
var templateObject_1;
